<div class="input-group">
  <select class="form-select text-center" [(ngModel)]="localeId" style="text-align-last: center;" aria-label="Location Selection" i18n-aria-label>
    @for (locale of locales; track locale) {
    <option [value]="locale.id">{{ locale.label }}</option>
    }
  </select>

  <select class="form-select text-center" [(ngModel)]="currency" style="text-align-last: center;" aria-label="Currency Selection" i18n-aria-label>
    @for (currency of currencies; track currency) {
    <option [value]="currency">{{ currency }}</option>
    }
  </select>
</div>